import React, { useContext } from 'react';
import { Card, CardContent, CardHeader, Stack } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { AppContext } from 'views/App/context';
import QuickAction from 'components/_atoms/QuickAction';
import { ArrowOutward, Storage, Description, BarChart } from '@mui/icons-material';

export default function LexipolReportSolutions() {
  const { currentOrganizationId, hasPermission } = useContext(AppContext);

  return (
    <Card className='lexipol-report-solutions lex-dashboard-card'>
      <CardHeader title={t('dashboard.lexipolReport.solutions.title')} />
      <CardContent>
        <Card>
          <CardContent>
            <Stack spacing={2}>
              {hasPermission('viewFieldBank', currentOrganizationId) && (
                <QuickAction
                  id='fieldBank'
                  title={t('dashboard.lexipolReport.solutions.fieldBank.title')}
                  subtitle={t('dashboard.lexipolReport.solutions.fieldBank.subtitle')}
                  href='/admin/performance-reporting/field-bank'
                  startIcon={<Storage />}
                  endIcon={<ArrowOutward />}
                />
              )}
              {hasPermission('viewFieldBank', currentOrganizationId) && (
                <QuickAction
                  id='templates'
                  title={t('dashboard.lexipolReport.solutions.templates.title')}
                  subtitle={t('dashboard.lexipolReport.solutions.templates.subtitle')}
                  href='/admin/performance-reporting/templates'
                  startIcon={<Description />}
                  endIcon={<ArrowOutward />}
                />
              )}
            </Stack>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
}
